module.exports = __webpack_public_path__ + "img/headervisual-768-2x.28219bee.jpg";